import { render } from "./Typer.vue?vue&type=template&id=87682f54&bindings={\"text\":\"props\",\"characterArray\":\"options\",\"currentText\":\"options\",\"currentInvisibleText\":\"options\",\"incrementTextIndex\":\"options\"}"
import script from "./Typer.vue?vue&type=script&lang=js"
export * from "./Typer.vue?vue&type=script&lang=js"
script.render = render

export default script